import { useEffect, useState } from 'react';
import { useWindowSize } from 'root/src/client/v2/common/hooks/useWindowSize';
const DEFAULT_DISPLAY_MEDIA_ITEMS = 2;
const displayMediaBreakpoints = [
    { width: 1550, items: 3 },
    { width: 0, items: 2 },
];
export const useRaceForRewardsPlayers = (media) => {
    const displayMediaPerRow = useDisplayMediaPerRow();
    const [totalDisplayMedia, setTotalDisplayMedia] = useState(displayMediaPerRow);
    const [displayedMedia, setDisplayedMedia] = useState([]);
    const onShowMoreClick = () => {
        if (totalDisplayMedia < media.length) {
            setTotalDisplayMedia(totalDisplayMedia + displayMediaPerRow);
        }
    };
    useEffect(() => {
        const isAligned = totalDisplayMedia % displayMediaPerRow === 0;
        if (!isAligned) {
            setTotalDisplayMedia((prevValue) => {
                const neededCountToBeAligned = (Math.ceil(totalDisplayMedia / displayMediaPerRow) * displayMediaPerRow) - totalDisplayMedia;
                return prevValue + neededCountToBeAligned;
            });
        }
    }, [displayMediaPerRow]);
    useEffect(() => {
        setDisplayedMedia(media.slice(0, totalDisplayMedia));
    }, [totalDisplayMedia]);
    const isAutoplay = (index) => index === 0;
    const displayShowMore = displayedMedia < media;
    return {
        displayedMedia,
        displayShowMore,
        onShowMoreClick,
        isAutoplay,
    };
};
export const useDisplayMediaPerRow = () => {
    const [width] = useWindowSize();
    const currentBreakpoint = displayMediaBreakpoints.find(breakpoint => width > breakpoint.width);
    if (!currentBreakpoint) {
        return DEFAULT_DISPLAY_MEDIA_ITEMS;
    }
    return currentBreakpoint.items;
};
